import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface OddsType {
  type: string;
  description: string;
}

const PromotionU888Section: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.promotions.title')}</title>
        <meta name="description" content={t('meta.promotions.description')} />
        <link rel="canonical" href="https://www.u888winbet.com/promotion" />
      </Helmet>
      <section className="bg-[#1a1a1a] text-xl text-white px-4 py-8 mt-[7rem] md:mt-[11rem]">
        {/* Title */}
        <h1 className="text-center text-2xl md:text-3xl font-bold text-[#ff5c00]">
          {t('promotion.title')}
        </h1>

        {/* Intro / Content */}
        <p className="max-w-3xl mx-auto leading-relaxed mt-5 whitespace-pre-line">
          {t('promotion.content')}
        </p>

        <div className="w-full max-w-5xl mx-auto mt-10 mb-10 px-4">
          <img
            src="/u888-banner.jpg"
            alt="U888 Promotion"
            className="rounded-md w-full h-auto"
          />
          <label className="block text-center italic mt-2 text-lg">
            {t('home.image_hint')}
          </label>
        </div>
      </section>
    </>
  );
};

export default PromotionU888Section; 